

































import { ExActAndConfigCouponInfo } from '@/types/coupon';
import { getPrizeDesc, getSpCouponInfo, getViewConfByCoupon } from '@/utils';
import { language } from '@tencent/ppd-base-libs';
import { Coupon, CouponVertical, CouponType } from '@tencent/wphk-act-base-ui';
import { biClick } from '@tencent/fit-bi-sdk';
import { computed, defineComponent, PropType, ref } from '@vue/composition-api';
import { useGrayStore } from '@/store/gray';
import { storeToRefs } from 'pinia';

export default defineComponent({
  name: 'CouponItem',
  props: {
    couponInfo: Object as PropType<ExActAndConfigCouponInfo>,
    // 是否锁
    isLock: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    Coupon,
    CouponVertical,
  },
  setup(prop, { emit }) {
    // 语言
    const lang = ref(language.isEn() ? 'en' : 'zh-hk');
    const { isGrayUser } = storeToRefs(useGrayStore());
    // 券是否锁定
    const isCouponLock = computed(() => !!(prop.isLock && prop.couponInfo?.isTimeLimitCoupon));
    // 券信息格式化
    const formatCouponInfo = computed(() => {
      if (prop.couponInfo) {
        const spCouponInfo = prop.couponInfo.isSpCoupon ? getSpCouponInfo() : {};
        const baseCouponInfo = prop.couponInfo.isDiscountCoupon ? {
          prizeDiscount: prop.couponInfo.discount,
        } : {
          prizeAmountYuan: prop.couponInfo.discount,
        };
        const extraCouponInfo = isGrayUser.value ? {
          // @ts-ignore
          goodsUrl: prop.couponInfo.goodsUrl || '',
          // @ts-ignore
          spDesc: prop.couponInfo.brandName || '',
          ...baseCouponInfo,
          pkgCount: (prop.couponInfo.perCount || 0) > 1 ? prop.couponInfo.perCount : 0, // 券包中券数量 / 一次派发张数
        } : {};
        // 券基本信息 + 方位配置
        return Object.assign(
          {
            couponType: CouponType.default,
            themeColor: 'green',
            // 券基本信息
            prizeLogo: prop.couponInfo.couponIcon, // 优惠券奖品logo
            prizeName: prop.couponInfo.couponName, // 优惠券名称
            prizeDesc: getPrizeDesc(prop.couponInfo),
            ...extraCouponInfo,
          },
          getViewConfByCoupon(prop.couponInfo, isCouponLock.value),
          spCouponInfo,
        );
      }
    });

    // 点击兑换按钮、点击整张券
    const couponClick = () => {
      console.log('=====couponClick', prop.couponInfo);
      biClick('rewards.rule_click', {
        fcouponName: prop.couponInfo?.couponName || '',
        fcouponId: prop.couponInfo?.couponId || '',
      });
      emit('onCouponClick', prop.couponInfo);
    };
    return {
      isGrayUser,
      formatCouponInfo,
      couponClick,
      lang,
      isCouponLock,
    };
  },
});
